import { render, staticRenderFns } from "./user-menu.vue?vue&type=template&id=56f10fbe&scoped=true"
import script from "./user-menu.vue?vue&type=script&lang=js"
export * from "./user-menu.vue?vue&type=script&lang=js"
import style0 from "./user-menu.vue?vue&type=style&index=0&id=56f10fbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f10fbe",
  null
  
)

/* custom blocks */
import block0 from "./user-menu.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports